export var NativeContext;
(function (NativeContext) {
    NativeContext[NativeContext["None"] = 0] = "None";
    NativeContext[NativeContext["AndroidGecko"] = 1] = "AndroidGecko";
    NativeContext[NativeContext["IosWebkit"] = 2] = "IosWebkit";
})(NativeContext || (NativeContext = {}));
//# sourceMappingURL=ICommonService.js.map